/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportOk } from '../../models/export-ok';
import { ExportTimeFrame } from '../../models/export-time-frame';

export interface ExportCasesWithTimeFrame$Params {
      body: ExportTimeFrame
}

export function exportCasesWithTimeFrame(http: HttpClient, rootUrl: string, params: ExportCasesWithTimeFrame$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportOk>> {
  const rb = new RequestBuilder(rootUrl, exportCasesWithTimeFrame.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportOk>;
    })
  );
}

exportCasesWithTimeFrame.PATH = '/api/v1/export/time';
